// extracted by mini-css-extract-plugin
export default {"showUnviewedRecordsOnly":"ShowUnviewedRecordsOnly_showUnviewedRecordsOnly__2M+7R","proBadge":"ShowUnviewedRecordsOnly_proBadge__HpZpQ"};